var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtectWhatYouLove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12633",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12634",
    d: "M20 11.242a10.345 10.345 0 01-7.48 9.686 1.914 1.914 0 01-1.04 0A10.344 10.344 0 014 11.242V7.214a2 2 0 011.243-1.851l4.864-1.99a5 5 0 013.787 0l4.864 1.99A2 2 0 0120 7.214z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12640",
    d: "M12 10.535A1.625 1.625 0 0113.232 10 1.81 1.81 0 0115 11.8c0 1.813-2.407 3.2-3 3.2s-3-1.389-3-3.2a1.81 1.81 0 011.768-1.8 1.625 1.625 0 011.232.535z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgProtectWhatYouLove;


//////////////////
// WEBPACK FOOTER
// ./src/icons/protectWhatYouLove.svg
// module id = 780
// module chunks = 13